import { render, staticRenderFns } from "./AcaoManutencao.vue?vue&type=template&id=4d773690&scoped=true&"
import script from "./AcaoManutencao.vue?vue&type=script&lang=js&"
export * from "./AcaoManutencao.vue?vue&type=script&lang=js&"
import style0 from "./AcaoManutencao.vue?vue&type=style&index=0&id=4d773690&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d773690",
  null
  
)

export default component.exports